import { qsa, add, remove } from "@fluorescent/dom";

const selectors = {
  items: ".animation--drawer-container > *",
};

const classes = {
  visible: "is-visible",
};

export default node => {
  function animate() {
    // Set the position offset on each time to be animated
    const items = qsa(selectors.items, node);
    
    items.forEach((item, i) => {
      item.style.setProperty("--position-offset-multiplier", i);
    });

    // Trigger the reveal animation when the drawer is opened.
    setTimeout(() => {
      add(node, classes.visible);
    }, 0);
  }

  function reset() {
    remove(node, classes.visible);
  }

  return {
    animate,
    reset,
  };
};
